import { AdminPanelSettings } from '@mui/icons-material'
import { Avatar, Box, colors } from '@mui/material'

import { useAuth } from '../../providers/auth'

export default function AccountImage() {
  const { user, admin } = useAuth()

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
      }}
      pt={4}
      mb={6}
    >
      <Box
        sx={{
          position: 'relative',
          width: 128,
          height: 128,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {!!user ? (
          <img
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              overflow: 'hidden',
            }}
            src={user!.photoURL !== "" ? user.photoURL : user.theme === 'light'? 'assets/defaultuser.png' : 'assets/defaultuserDark.png' }
            alt={user!.displayName ?? 'Unknown'}
          />
        ) : (
          'loading'
        )}

        {admin && (
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              zIndex: 100,
            }}
          >
            <Avatar sx={{ bgcolor: colors.green[500] }}>
              <AdminPanelSettings />
            </Avatar>
          </Box>
        )}
      </Box>
    </Box>
  )
}
